var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanLoopCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8794 1.16507L1.10287 2.70759C1.03938 2.74286 1 2.80978 1 2.88242V10.8956C1 11.0481 1.16382 11.1445 1.29713 11.0704L4.07366 9.52789C4.13715 9.49262 4.17653 9.42569 4.17653 9.35306V1.3399C4.17653 1.18741 4.01271 1.09101 3.8794 1.16507Z",
    stroke: "#0550DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82422 9.3637V1.3737C9.82422 1.21396 10.0022 1.11869 10.1352 1.20729L12.9117 3.05831C12.9673 3.0954 13.0007 3.15785 13.0007 3.22472V11.2147C13.0007 11.3745 12.8227 11.4697 12.6898 11.3811L9.91328 9.53011C9.85764 9.49302 9.82422 9.43057 9.82422 9.3637Z",
    stroke: "#0550DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89336 2.69849L4.48178 1.19125C4.34857 1.10799 4.17578 1.20376 4.17578 1.36085V9.35989C4.17578 9.42885 4.21131 9.49294 4.26978 9.52949L6.89336 11.1692C6.95822 11.2098 7.04051 11.2098 7.10536 11.1692L9.72894 9.52949C9.78742 9.49294 9.82294 9.42885 9.82294 9.35989V1.36085C9.82294 1.20376 9.65015 1.10799 9.51694 1.19125L7.10536 2.69849C7.04051 2.73902 6.95822 2.73902 6.89336 2.69849Z",
    stroke: "#0550DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.76562V11.2364",
    stroke: "#0550DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanLoopCard);
export default __webpack_public_path__ + "static/media/PlanLoopCard.aacb02d317c2eb7c4fb92b608396e969.svg";
export { ForwardRef as ReactComponent };